export default __webpack_public_path__ + "static/media/icon1.1d5fc9ef.png";